import {useNavigate, useParams} from "react-router-dom";
import {
    buildMutualBettingSubTypes,
    buildMutualBettingTypes,
    bulletinProvider,
} from "../../../features/bulletin/bulletin.service";
import paths from "../../../paths";
import {useAvailableHippodromes, useDailyRaces} from "../../../features/bulletin/bulletin.store";
import React, {useEffect, useRef} from "react";
import {Hippodrome} from "../../../models/bulletin.models";
import {MutualBetslipSidebar} from "./mutual.betslip";
import {MutualBetslip, useMutualSlipOptions} from "../../../features/betslip/mutual.service";
import {
    asModalHtml,
    degradeMessage,
    degradeTarget,
    groupRunNos,
    mutualBreakMessage,
    mutualSelectionBreak,
} from "../../../features/betslip/lib/selection-guard";
import {modalServiceSubject} from "../../../services/modal.service";
import {BettingTypeOptions} from "../components/betting-options";
import {BettingDataTable} from "../components/betting-datatable";
import {BettingDataTabs} from "../components/betting-tabs";
import {isMobile} from "../../../App";
import {HippodromeWidget} from "../../../shared/hippodrome/hippodrome";

export function BettingRoot() {
    const navigator = useNavigate();
    // Bülten güncellemesinde yeniden çizim artık anlık görüntüden geliyor.
    const dailyRaces = useDailyRaces();
    const availableHippodromes = useAvailableHippodromes();

    useEffect(() => {
        bulletinProvider.refreshAvailableHippodromes();
    }, []);

    useEffect(() => {
        if (dailyRaces.length === 0) {
            return;
        }
        let activeAvailableHippodromes = availableHippodromes.filter((el: any) => el.wager_details.length > 0);
        if (activeAvailableHippodromes.length > 0) {
            navigator(`${paths.betting.url}/${activeAvailableHippodromes[0].keyword.toLowerCase()}${activeAvailableHippodromes[0]._id}`, {replace: true});
        } else {
            navigator(`${paths.home.url}`, {replace: true});
        }

    }, [availableHippodromes.length, dailyRaces.length]);


    return (<></>)
}

export function Betting() {
    const params: any = useParams();
    const slipOptions = useMutualSlipOptions();
    const dailyRaces = useDailyRaces();
    const availableHippodromes = useAvailableHippodromes();
    const navigator = useNavigate();
    const hippodrome = availableHippodromes.find((hippodrome: Hippodrome) => hippodrome.keyword.toLowerCase() + hippodrome._id === params.hippodrome?.toLowerCase());
    const redirectTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
    const shownBreakKey = useRef<string | null>(null);
    const dialogOpen = useRef<boolean>(false);

    useEffect(() => {
        bulletinProvider.refreshAvailableHippodromes();
    }, []);

    useEffect(() => {
        const opts = MutualBetslip.getOptions();
        if (opts.bettingType) {
            const types = buildMutualBettingTypes(hippodrome);
            let nextType = types.find((b: any) => b.id === opts.bettingType.id);
            if (!nextType && types.length > 0) {
                nextType = types[0];
                MutualBetslip.setOptions({hippodrome, bettingType: nextType, column: 1});
            }
            const subTypes = buildMutualBettingSubTypes(nextType ?? opts.bettingType);
            if (!subTypes.find((b: any) => b.id === MutualBetslip.getOptions().bettingSubType?.id) && subTypes.length > 0) {
                MutualBetslip.setOptions({bettingSubType: subTypes[0], column: 1});
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dailyRaces]);

    useEffect(() => {
        if (!hippodrome) {
            return;
        }
        const types = buildMutualBettingTypes(hippodrome);
        const opts = MutualBetslip.getOptions();
        const hippodromeChanged = opts.hippodrome?._id !== hippodrome._id;
        if (!opts.bettingType || hippodromeChanged) {
            const nextType = types.find((b: any) => b.id === 18) ?? types[0];
            if (nextType) {
                MutualBetslip.setOptions({
                    hippodrome,
                    bettingType: nextType,
                    bettingSubType: buildMutualBettingSubTypes(nextType)[0],
                    column: 1,
                    ...(hippodromeChanged ? {betSlipMultiply: 1, usePointBalance: false} : {}),
                });
                return;
            }
        }
        MutualBetslip.setOptions({hippodrome});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hippodrome?._id, dailyRaces]);

    useEffect(() => {
        if (hippodrome) {
            return;
        }
        redirectTimer.current = setTimeout(() => {
            if (dailyRaces.length === 0) {
                return;
            }
            const activeAvailableHippodromes = availableHippodromes.filter((el: any) => el.wager_details.length > 0);
            if (activeAvailableHippodromes.length > 0) {
                navigator(`${paths.betting.url}/${activeAvailableHippodromes[0].keyword.toLowerCase()}${activeAvailableHippodromes[0]._id}`, {replace: true});
            } else {
                navigator(paths.home.url, {replace: true});
            }
        }, 3000);
        return () => {
            if (redirectTimer.current) {
                clearTimeout(redirectTimer.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hippodrome?._id, params.hippodrome, dailyRaces.length, availableHippodromes.length]);

    // Bülten tick'inde seçim bağlamı kırıldıysa: tek düğmeli modal, onayında kuponun bu
    // bağlamdaki satırlarını temizle ve sayfayı AÇILIŞ yolundan yeniden kur (BettingRoot
    // zaten "açık olan ilk kartı seç" mantığını taşıyor). Müşterekte sessiz taşıma
    // YAPILMIYOR - kupon (kart+tür+alt tür) bağlamına kilitli olduğu için taşımak
    // seçimleri silmeden görünmez yapardı.
    useEffect(() => {
        if (dialogOpen.current) {
            return;
        }
        const options = MutualBetslip.getOptions();
        // Gönderim uçuştayken bağlam değiştirilmez; kupon gidene kadar bekler.
        // Alt tür de ŞART: bağlam kurulmadan kırılma değerlendirilmemeli. Bu sayfada tür ve
        // alt tür tek `setOptions` çağrısında birlikte set edildiği için bugün o pencere yok,
        // ama 4nala'da vardı ve her sayfa yenilemesinde "-. koşu kapandı" modalı çıkıyordu.
        if (!options.hippodrome ||
            !options.bettingType ||
            !options.bettingSubType ||
            options.inProgress) {
            return;
        }
        const brk = mutualSelectionBreak({
            card: options.hippodrome,
            availableCards: availableHippodromes,
            typeId: options.bettingType?.id,
            subTypeId: options.bettingSubType?.id,
        });
        if (brk === "ok") {
            shownBreakKey.current = null;
            return;
        }
        // Aynı kırılma için BİR modal: tick saniyede bir aynı şeyi bildiriyor.
        const key = `${brk}:${options.hippodrome?._id}:${options.bettingType?.id}:${options.bettingSubType?.id}`;
        if (shownBreakKey.current === key) {
            return;
        }
        shownBreakKey.current = key;
        dialogOpen.current = true;

        const cleared = MutualBetslip.getCurrentItems().length;

        // Önce ZİNCİR denenir: ayak kapandığında kullanıcıyı bültenin dışına atmak yerine bir
        // alt basamağa bırakıyoruz (7'li → 6'lı → ... → Çifte → Ganyan). Kupon her iki yolda
        // da boşalıyor; fark yalnız nereye düştüğü. Hedef yoksa aşağıdaki sıfırlama yolu.
        const chainTarget = degradeTarget({
            brk,
            card: options.hippodrome,
            currentType: options.bettingType,
            groupRuns: groupRunNos(options.bettingSubType?.label),
        });
        if (chainTarget) {
            const fromName = options.bettingType?.name ?? "";
            MutualBetslip.clear();
            MutualBetslip.setOptions({
                bettingType: chainTarget.type,
                bettingSubType: chainTarget.subType,
                column: 1,
                betSlipMultiply: 1,
                complete: false,
            });
            modalServiceSubject.next({
                title: "Bahisler kapandı",
                case: "warning",
                innerHtml: true,
                content: asModalHtml(degradeMessage({
                    closedRunNo: chainTarget.closedRunNo,
                    fromTypeName: fromName,
                    toTypeName: chainTarget.type.name,
                    clearedCount: cleared,
                })),
                onClose: () => {
                    dialogOpen.current = false;
                },
                confirm: {
                    cancel: {
                        label: "Tamam",
                        action: () => {
                            dialogOpen.current = false;
                        },
                    },
                },
            });
            return;
        }

        let handled = false;
        const resume = () => {
            if (handled) return;
            handled = true;
            dialogOpen.current = false;
            MutualBetslip.clear();
            // Kök rotaya dön: açılış yolu açık olan ilk kartı/türü seçsin.
            navigator(paths.betting.url);
        };

        modalServiceSubject.next({
            title: "Bahisler kapandı",
            case: "warning",
            innerHtml: true,
            content: asModalHtml(mutualBreakMessage({
                brk,
                cardName: options.hippodrome?.hippodrome,
                typeName: options.bettingType?.name,
                subTypeId: options.bettingSubType?.id,
                clearedCount: cleared,
            })),
            onClose: resume,
            confirm: {cancel: {label: "Tamam", action: resume}},
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dailyRaces, availableHippodromes]);

    const selectBettingColumn = (no: any) => {
        MutualBetslip.setOptions({column: Number(no)});
    }

    const selectBettingSubType = (id: any) => {
        const subTypes = buildMutualBettingSubTypes(MutualBetslip.getOptions().bettingType);
        MutualBetslip.setOptions({
            betSlipMultiply: 1,
            complete: false,
            bettingSubType: subTypes.find((el: any) => Number(el.id) === Number(id)) ?? subTypes[0],
            column: 1,
        });
    }

    const selectBettingType = (id: any) => {
        const types = buildMutualBettingTypes(hippodrome);
        const nextType = types.find((el: any) => Number(el.id) === Number(id));
        const subTypes = buildMutualBettingSubTypes(nextType);
        MutualBetslip.setOptions({
            hippodrome,
            bettingType: nextType,
            bettingSubType: subTypes[0],
            column: 1,
            betSlipMultiply: 1,
            complete: false,
        });
    }

    if (!hippodrome) {
        return (<div className={"container betting-container pb-5"}>
            <div className={"page-widget"}>
                <div className="hint-text text-center p-3" style={{minHeight: "50vh"}}>
                    <p className={"fs-6 mb-0 text-black"}>
                        {dailyRaces.length === 0 ? 'Bülten yükleniyor...' : 'Bu hipodromda açık koşu bulunmamaktadır.'}
                    </p>
                </div>
            </div>
        </div>)
    }

    const availableBettingTypes = buildMutualBettingTypes(hippodrome);

    return (<>
        {!isMobile && <HippodromeWidget/>}
        <div className={"container betting-container pb-5"}>
            <BettingTypeOptions params={params} hippodrome={hippodrome}
                                selection={slipOptions}
                                selectBettingType={selectBettingType}
                                selectBettingSubType={selectBettingSubType}/>
            <div className="row">
                {!params.subpage && <>
                    <div className={`${availableBettingTypes.length > 0 ? "p-0" : 'col-12'}`}>

                        {availableBettingTypes.length > 0 && <div className="page-widget">

                            <BettingDataTabs selection={slipOptions} selectBettingColumn={selectBettingColumn}/>

                            <BettingDataTable selection={slipOptions} selectBettingColumn={selectBettingColumn}/>
                        </div>}

                        {/* Kartta bahis KALMIŞ olabilir ama hepsi sabit ihtimalli (FOB) olabilir:
                            o zaman bu sayfada seçilebilecek müşterek tür sıfırdır ve içerik alanı
                            bomboş kalıyordu. Koşul `wager_details.length` yerine bu sayfanın
                            gerçekten gösterebildiği tür sayısına bakıyor. Bugün Elazığ tam olarak
                            bu durumda: 6 bahsi de FOB, müşterek türü yok. */}
                        {availableBettingTypes.length === 0 && hippodrome.wager_details.length > 0 &&
                            <div className={"page-widget"}>
                                <div className="hint-text text-center p-3" style={{minHeight: "50vh"}}>
                                    <p className={"fs-6 mb-0 text-black"}>Bu hipodromda müşterek bahis
                                        kalmamıştır. Sabit ihtimalli bahisler için "Sabit İhtimalli
                                        Bahis" sayfasını kullanabilirsiniz.</p>
                                </div>
                            </div>}

                        {hippodrome.wager_details.length === 0 &&
                            <div className={"page-widget"}>
                                <div className="hint-text text-center p-3" style={{minHeight: "50vh"}}>
                                    <p className={"fs-6 mb-0 text-black"}>Bu hipodromda açık koşu
                                        bulunmamaktadır.</p>
                                </div>
                            </div>}


                    </div>
                </>}
            </div>
            {!isMobile && slipOptions.bettingSubType && slipOptions.bettingType?.id !== 0 && <MutualBetslipSidebar/>}
        </div>
    </>)
}
